export const ASPECT_RATIO = 16 / 9;
export const MIN_WIDTH = 1000;
export const MIN_HEIGHT = Math.round(MIN_WIDTH / ASPECT_RATIO);
export const MAX_IMAGE_FILE_SIZE = 25 * 1000 * 1024; // 25MB
